export function selectActiveRowByDetail() {
	if (window.location.hash.match(/^#\!detail\-/)) {
		let pk = window.location.hash.replace('#!detail-', '');
		let node = window.gridSettings.api.getRowNode(pk);
		if (node) {
			node.setSelected(true, true);
			window.gridSettings.api.setFocusedCell(node.rowIndex, 'id');
		}
	}
}
